<template>
    <div class="ip-item flex">
        <el-input
            v-model="ipaddressStart"
            placeholder="请输入起始IP"
            @change="startIpChange"
        ></el-input>
        <span class="mx-2">至</span>
        <el-input
            v-model="ipaddressEnd"
            placeholder="请输入结束IP"
            @change="endIpChange"
        ></el-input>
    </div>
</template>
<script setup lang="ts">
defineProps({
    ipaddressStart: {
        type: String
    },
    ipaddressEnd: {
        type: String
    }
})
const emits = defineEmits(['update:ipaddressStart', 'update:ipaddressEnd'])

const startIpChange = (value: string): void => {
    emits('update:ipaddressStart', value)
}
const endIpChange = (value: string): void => {
    emits('update:ipaddressEnd', value)
}
</script>
<style lang="scss" scoped></style>
